// angular
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// managers
import { GrowlManager } from '../../manager/growl.manager';
import { ModelsManager } from '../../manager/models.manager';
// services
import { ServerMapping } from '../../service/serverMapping.service';
// models
import { LotCharactsRequest } from './../../model/lot/lot_characts_request.model';
import { LotCharactsResponse } from './../../model/lot/lot_characts_response.model';

@Injectable()
export class LotCharactsService {

  private searching = false;
  private contained_bean = undefined;

  constructor(private growlManager:     GrowlManager,
              private serverMapping:    ServerMapping,
              private modelManager:     ModelsManager,
              private http:             Http) {}

  isSearching() { return this.searching; }

  searchCharacts() {
    if (this.searching === false ) {
      this.searching = true;
      this.http.get(this.serverMapping.lotCharacteristicURL +
        '?lot_number=' + this.modelManager.lot_characts_request.lot_number +
        '&language=' + this.modelManager.lot_characts_request.language).subscribe
        (
          (response) => {
            // store the response
            const data = response.json();
            if (this.growlManager.checkForErrorInResponse(data)) {
              this.growlManager.showMessagesByResponse(data);
            } else {
              this.modelManager.lot_characts_response = data;
            }

            this.searching = false;

            // response verify in console
            // console.log('IL SERVER RITORNA');
            // console.log(this.modelManager.lot_characts_response);
            // console.log('BEAN');
            // console.log(this.modelManager.lot_characts_response.contained_bean);
          },
          (error) => {
            console.log('--------------------------------');
            console.log('!!!An error has been occurred!!!');
            console.log(error);
            console.log('--------------------------------');
          }
        );
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-lot-characts/lot-characts.service.ts